module.exports = __webpack_public_path__ + "u.no2.57957045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u.no2.jpg
// module id = emb6
// module chunks = 0